import type { Translations } from './Localizations';
import { DEFAULT_TRANSLATIONS } from './Localizations';

export interface AppConfiguration {
  basketLink: string;
  staticApiUrl: string;
  tenant: string;
  translations: Translations;
}

export const DEFAULT_CONFIG = {
  basketLink: '',
  staticApiUrl: '',
  tenant: '',
  translations: DEFAULT_TRANSLATIONS,
};
